<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="正式订单" min-width="100" prop="zhengshidingdan"></el-table-column>
          <el-table-column align="center" label="产品代码" min-width="100" prop="chanpindaima"></el-table-column>
          <el-table-column align="center" label="产品名称" min-width="100" prop="chanpinmingcheng"></el-table-column>
          <el-table-column align="center" label="单位" min-width="100" prop="danwei"></el-table-column>
          <el-table-column align="center" label="订单数量" min-width="100" prop="dingdanshuliang"></el-table-column>
          <el-table-column align="center" label="部件名称" min-width="150" prop="bujianmingcheng"></el-table-column>
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="计件单价" min-width="100" prop="jijiandanjia"></el-table-column>
          <el-table-column align="center" label="成控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          <el-table-column align="center" label="添加时间" min-width="100" prop="createTime"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="正式订单" prop="zhengshidingdan">
          <div style="display: flex;">
            <el-input v-model="editForm.zhengshidingdan" style="margin-right: 10px;"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="产品代码" prop="chanpindaima">
          <el-input v-model="editForm.chanpindaima"></el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="chanpinmingcheng">
          <el-input v-model="editForm.chanpinmingcheng"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="danwei">
          <el-input v-model="editForm.danwei"></el-input>
        </el-form-item>
        <el-form-item label="订单数量" prop="dingdanshuliang">
          <el-input-number v-model="editForm.dingdanshuliang" :precision="0" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="部件名称" prop="bujianmingcheng">
          <el-input v-model="editForm.bujianmingcheng"></el-input>
        </el-form-item>
        <el-form-item label="工序" prop="gongxu">
          <el-input v-model="editForm.gongxu"></el-input>
        </el-form-item>
        <el-form-item label="计件单价" prop="jijiandanjia">
          <el-input-number v-model="editForm.jijiandanjia" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="成控单价" prop="chengkongdanjia">
          <el-input-number v-model="editForm.chengkongdanjia" :precision="4" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    zhengshidingdan: "",
    chanpindaima: "",
    chanpinmingcheng: "",
    danwei: "",
    dingdanshuliang: 0,
    bujianmingcheng: "",
    gongxu: "",
    jijiandanjia: "",
    chengkongdanjia: "",
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    add() {
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/Ordermodel/biantengMbInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/Ordermodel/biantengMbDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = this.editForm
          data.riqi = parseInt(data.riqi/1000)
          this.$request.post('/index.php/admin/Ordermodel/biantengMbSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      this.$request.post('/index.php/admin/Ordermodel/biantengMbList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
